import './manager-panel.scss'

import {
  useTranslation,
} from 'react-i18next'
import {
  Box,
  Button,
  Typography,
} from '@mui/material'
import {
  HourglassTop,
} from '@vedmarket/ui-kit'
import {
  COLORS,
} from 'config/constants'

import {
  showManagerContactsSummary,
  showManagerExecutorWorkflowStep,
  showManagerOutcome,
  showManagerPackageReview,
  showManagerPreparationTools,
  showManagerProposalTools,
  showManagerRevealContacts,
  showManagerTakeWork,
} from '../detail-visibility'

import ManagerWorkflowPanel from './manager-workflow-panel'

const ApplicationManagerPanel = ({ panel }: ApplicationManagerPanelProps) => {
  const props = panel
  const { app, managerView, runAction, onTakeWork } = props
  const { t } = useTranslation()

  if (!managerView) return null

  const canTakeWork = showManagerTakeWork({ app: app, managerView: managerView })
  const showWorkflow = Boolean(app.manager_id) && !canTakeWork
  const showAny = canTakeWork
    || (app.manager_id && (
      showManagerExecutorWorkflowStep({ app: app, managerView: managerView })
      || showManagerPreparationTools({ app: app, managerView: managerView })
      || showManagerPackageReview({ app: app, managerView: managerView })
      || showManagerProposalTools({ app: app, managerView: managerView })
      || showManagerRevealContacts({ app: app, managerView: managerView })
      || showManagerContactsSummary({ app: app, managerView: managerView })
      || showManagerOutcome({ app: app, managerView: managerView })
    ))

  if (!showAny) return null

  return (
    <Box className='application-manager-panel'>
      {showWorkflow && <ManagerWorkflowPanel panel={panel} />}

      {canTakeWork && (
        <div className='application-manager-panel__actions'>
          <Button
            variant='contained'
            onClick={() => runAction(() => onTakeWork(), 'applications__message__workTaken')}
            disabled={panel.isTakingWork}
            sx={{
              width: '280px',
              maxWidth: '100%',
            }}
          >
            <HourglassTop style={{
              marginRight: '8px',
              fill: COLORS.WHITE,
            }} />
            <Typography component='span' variant='inherit' sx={{ fontWeight: 'inherit' }}>
              {t('applications__text__takeToWork')}
            </Typography>
          </Button>
        </div>
      )}
    </Box>
  )
}

export default ApplicationManagerPanel
